var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import { MessageBus } from "@podium/browser";
import {
  atom as nsAtom,
  map as nsMap,
  deepMap as nsDeepMap,
  clean,
  cleanStores,
  batched,
  computed,
  keepMount,
  onMount,
  onNotify,
  onSet,
  onStart,
  onStop,
  STORE_UNMOUNT_DELAY,
  listenKeys,
  subscribeKeys,
  mapCreator,
  allTasks,
  cleanTasks,
  startTask,
  task
} from "nanostores";
export {
  clean,
  cleanStores,
  batched,
  computed,
  keepMount,
  onMount,
  onNotify,
  onSet,
  onStart,
  onStop,
  STORE_UNMOUNT_DELAY,
  listenKeys,
  subscribeKeys,
  mapCreator,
  allTasks,
  cleanTasks,
  startTask,
  task
};
const messageBus = new MessageBus();
function getInitialValue(channel, topic, initialValue) {
  const initialFromBus = messageBus.peek(channel, topic);
  if (!initialFromBus) {
    messageBus.publish(channel, topic, initialValue);
  }
  const initial = (initialFromBus == null ? void 0 : initialFromBus.payload) || initialValue;
  return initial;
}
export function atom(channel, topic, initialValue) {
  const initial = getInitialValue(channel, topic, initialValue);
  const $store = nsAtom(initial);
  const listener = (event) => {
    $store.set(event.payload);
  };
  messageBus.subscribe(channel, topic, listener);
  $store.listen((value) => {
    const lastValue = messageBus.peek(channel, topic);
    if (lastValue && lastValue.payload === value) {
      return;
    }
    messageBus.publish(channel, topic, value);
  });
  return $store;
}
export function map(channel, topic, initialValue) {
  const initial = getInitialValue(channel, topic, initialValue);
  const $store = nsMap(initial);
  let source = "app";
  const listener = (event) => {
    source = "bus";
    $store.set(__spreadValues({}, event.payload));
  };
  messageBus.subscribe(channel, topic, listener);
  $store.listen((value) => {
    if (source !== "bus") {
      messageBus.publish(channel, topic, value);
    } else {
      source = "app";
    }
  });
  return $store;
}
export function deepMap(channel, topic, initialValue) {
  const initial = getInitialValue(channel, topic, initialValue);
  const $store = nsDeepMap(initial);
  let source = "app";
  const listener = (event) => {
    source = "bus";
    $store.set(__spreadValues({}, event.payload));
  };
  messageBus.subscribe(channel, topic, listener);
  $store.listen((value) => {
    if (source !== "bus") {
      messageBus.publish(channel, topic, value);
    } else {
      source = "app";
    }
  });
  return $store;
}
